import { createIcon } from './utils';

const Icon = createIcon();

export default Icon;
